import React from "react";
import styled from "styled-components";
import cx from "classnames";
import useBreakpoint from "utils/hooks/useBreakpoint";

const Card = styled.button`
  ${({ isMobile }) =>
    !isMobile &&
    `
    &:hover {
      & > h2 {
        color: white;
      }
      & > p {
        color: white;
      }
    }
  `}
`;

const Copy = styled.p`
  letter-spacing: -0.01em;
`;

const MarketCard = (props) => {
  const { name, shortDescription, selectedMarket, handleMarketChange } = props;

  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  const blueCard = selectedMarket === name && !isMobile;

  return (
    <Card
      className={cx(
        "w-full rounded ml-5 mb-8 md:mb-0 md:py-6 transition-all duration-200",
        {
          "bg-action-blue": blueCard,
          "hover:bg-action-blue": !isMobile,
        }
      )}
      isMobile={isMobile}
      onClick={() => {
        handleMarketChange(name);
      }}
      aria-label={"View contact details of " + name}
      aria-expanded={selectedMarket === name}
    >
      <h2
        className={cx(
          "text-3xl font-trade-gothic-20 leading-6 md:leading-7 tracking-tight mt-1 mb-2",
          {
            "text-white": blueCard,
            "text-mattamy-blue": !blueCard,
          }
        )}
      >
        {name}
      </h2>
      <Copy
        className={cx("font-graphie leading-7", {
          "text-white": blueCard,
          "text-action-blue": !blueCard,
        })}
      >
        {shortDescription}
      </Copy>
    </Card>
  );
};
export default MarketCard;
